import { styled } from "goober";
import { Link } from "../../Link";

export const PermissionRowContent = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const RowActionPlaceholder = styled("div")`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const SubHeader = styled("div")`
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-bottom: 0.5px solid var(--border-alpha);
`;

export const ScopeTabs = styled("div")`
  display: flex;
  gap: 8px;
  padding: 8px 0;
`;

export const ScopeFilterTab = styled(Link)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  border: none;
  outline: none;
  background: none;
  text-decoration: none;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 24px;
  cursor: pointer;
  color: var(--text-secondary);
  &[data-active="true"] {
    color: var(--text-primary);
    background: var(--alpha4);
  }
  &:hover {
    background: var(--alpha4);
  }
`;
